<script>
import { cloneDeep } from 'lodash-es';
import { mapActions, mapState } from 'vuex';
import ItineraryDayProgramListExpandedRow from './ItineraryDayProgramListExpandedRow';

export default {
  name: 'ItineraryDayProgramDayTextModal',
  components: {
    ItineraryDayProgramListExpandedRow,
  },
  props: {
    itineraryId: {
      type: Number,
      required: true,
    },
    dayProgramEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toggled: true,
      loading: false,
      error: false,
      dayProgramDomain: null,
      dayProgram: null,
    };
  },
  mounted() {
    this.dayProgram = this.dayProgramEntry;
    if (this.selectedDomain) {
      this.setDayProgramDomain();
    }
  },
  methods: {
    ...mapActions({
      updateDayProgramDayText: 'itinerary/updateDayProgramDayText',
    }),
    setDayProgramDomain() {
      const selectedDomainDayPrograms = cloneDeep(this.selectedDomain.dayPrograms);
      this.dayProgramDomain = selectedDomainDayPrograms
        .filter(dayProgram => dayProgram.itineraryDayProgramId === this.dayProgram.id)[0]
        || null;
    },
    saveDayText() {
      this.loading = true;
      this.updateDayProgramDayText({
        itineraryId: this.itineraryId,
        dayProgramId: this.dayProgram.id,
        refreshList: true,
        data: this.dayTextPayload,
      }).then(() => {
        this.loading = false;
        this.$emit('close');
      }).catch(() => {
        this.loading = false;
        this.error = true;
      });
    },
    updateDayProgramDomain(event) {
      this.dayProgramDomain[event.model] = event.value;
    },
    updateDayProgram(event) {
      this.dayProgram[event.model] = event.value;
    },
  },
  computed: {
    ...mapState({
      selectedDomain: state => state.itinerary.domains.selected,
    }),
    dayTextPayload() {
      return {
        dayText: {
          teaserText: this.dayProgram.teaserText,
          text: this.dayProgram.text,
        },
        dayTextDomain: this.dayProgramDomain ? {
          teaserText: this.dayProgramDomain.teaserText,
          text: this.dayProgramDomain.text,
        } : null,
      };
    },
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('close');
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
    :persistent="loading"
  >
    <v-card>
      <v-container v-if="!loading">
        <v-flex font-weight-bold pa-3 title>
          Day Text
        </v-flex>
        <template>
          <itinerary-day-program-list-expanded-row
            v-if="dayProgramDomain"
            :title="$t('itinerary.edit.dayProgram.localText')"
            :item="dayProgramDomain"
            :index="0"
            class="expanded-row-form"
            @input="updateDayProgramDomain"
          />
          <itinerary-day-program-list-expanded-row
            v-if="dayProgram"
            :title="$t('itinerary.edit.dayProgram.supplierText')"
            :item="dayProgram"
            :index="0"
            class="expanded-row-form"
            @input="updateDayProgram"
          />
        </template>
      </v-container>
      <v-container v-else-if="error">
        <v-flex pa-3>
          An error occured. Contact IT.
        </v-flex>
      </v-container>
      <v-container v-else>
        <v-layout justify-center>
          <v-progress-circular indeterminate />
        </v-layout>
      </v-container>
      <v-divider light/>
      <v-layout justify-end>
        <v-btn
          :disabled="loading"
          color="red darken-1"
          flat
          @click="$emit('close')"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="loading || error"
          color="blue darken-1"
          flat
          @click="saveDayText"
        >
          Save
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramDayTextModal.vue